import React, { useState, useEffect } from 'react';
import { prizeTexts } from '../contexts/LangHO2';
import crn_ai100Img from '../assets/images/halcyon/crn_ai100.png';
import globalinforsecawardsImg from '../assets/images/halcyon/globalinforsecawards.png';
import cybersecurityImg from '../assets/images/halcyon/cybersecurity.png';
import scawardsImg from '../assets/images/halcyon/scawards.png';
import crn_winnerImg from '../assets/images/halcyon/crn_winner.png';
import forbesImg from '../assets/images/halcyon/forbes.png';
import theinformationImg from '../assets/images/halcyon/theinformation.png';
import fortuneImg from '../assets/images/halcyon/fortune.png';
import cyberdefenseImg from '../assets/images/halcyon/cyberdefense.png';
import enterprisesecurityImg from '../assets/images/halcyon/enterprisesecurity.png';
import fc_bigthingsImg from '../assets/images/halcyon/fc_bigthings.png';
import fc_innovativeImg from '../assets/images/halcyon/fc_innovative.png';

function ProductHOPrize2({ lang = 'ko', isMobile = false }) {
  const [currentIndex, setCurrentIndex] = useState(12); // 중간 섹션에서 시작
  const [isTransitioning, setIsTransitioning] = useState(true);

  // 12개의 상 정보를 배열로 정리
  const prizes = [
    { key: 'crn_ai100', image: crn_ai100Img, text: prizeTexts.group.crn_ai100[lang] },
    { key: 'globalinforsecawards', image: globalinforsecawardsImg, text: prizeTexts.group.globalinforsecawards[lang] },
    { key: 'cybersecurity', image: cybersecurityImg, text: prizeTexts.group.cybersecurity[lang] },
    { key: 'scawards', image: scawardsImg, text: prizeTexts.group.scawards[lang] },
    { key: 'crn_winner', image: crn_winnerImg, text: prizeTexts.group.crn_winner[lang] },
    { key: 'forbes', image: forbesImg, text: prizeTexts.group.forbes[lang] },
    { key: 'theinformation', image: theinformationImg, text: prizeTexts.group.theinformation[lang] },
    { key: 'fortune', image: fortuneImg, text: prizeTexts.group.fortune[lang] },
    { key: 'cyberdefense', image: cyberdefenseImg, text: prizeTexts.group.cyberdefense[lang] },
    { key: 'enterprisesecurity', image: enterprisesecurityImg, text: prizeTexts.group.enterprisesecurity[lang] },
    { key: 'fc_bigthings', image: fc_bigthingsImg, text: prizeTexts.group.fc_bigthings[lang] },
    { key: 'fc_innovative', image: fc_innovativeImg, text: prizeTexts.group.fc_innovative[lang] }
  ];

  // 무한 루프를 위해 앞뒤로 복제된 배열 생성
  const extendedPrizes = [...prizes, ...prizes, ...prizes];
  const cloneCount = prizes.length;

  // 자동 슬라이드 효과
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => prevIndex + 1);
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  // 무한 루프를 위한 리셋 처리
  useEffect(() => {
    if (currentIndex >= cloneCount * 2) {
      // 마지막 복제본 영역에 도달하면 첫 번째 복제본으로 리셋
      const timer = setTimeout(() => {
        setIsTransitioning(false);
        setCurrentIndex(cloneCount);
        setTimeout(() => setIsTransitioning(true), 50);
      }, 600);
      return () => clearTimeout(timer);
    } else if (currentIndex < cloneCount) {
      // 첫 번째 복제본 이전으로 가면 두 번째 복제본으로 리셋
      const timer = setTimeout(() => {
        setIsTransitioning(false);
        setCurrentIndex(cloneCount + currentIndex);
        setTimeout(() => setIsTransitioning(true), 50);
      }, 600);
      return () => clearTimeout(timer);
    }
  }, [currentIndex, cloneCount]);

  return (
    <div
      style={{
        width: '100vw',
        maxWidth: '100vw',
        // background: '#0066CC',
        background: 'rgba(255, 255, 255, 0.1)',
        borderRadius: 12,
        boxShadow: '0 2px 12px rgba(0,0,0,0.10)',
        padding: isMobile ? '0 10px' : '0',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
      }}
    >
      <span style={{
        fontSize: isMobile ? '1.7rem' : '2rem',
        fontWeight: 700,
        color: '#fff',
        marginBottom: isMobile ? 12 : 16,
        paddingLeft: isMobile ? 20 : 40,
        paddingRight: isMobile ? 20 : 40,
        paddingTop: isMobile ? 20 : 28,
        display: 'block',
        letterSpacing: '-0.02em',
        textAlign: 'center',
        width: '100%'
      }}>
        {prizeTexts.title[lang]}
      </span>
      
      {/* 수평 슬라이딩 캐러셀 영역 */}
      <div style={{
        width: '100%',
        padding: isMobile ? '0 20px' : '0 40px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        overflow: 'hidden'
      }}>
        {/* 슬라이딩 컨테이너 */}
        <div style={{
          width: '100%',
          maxWidth: isMobile ? '100%' : '1200px',
          overflow: 'hidden',
          position: 'relative'
        }}>
          <div style={{
            display: 'flex',
            width: isMobile ? `${extendedPrizes.length * 100}%` : '100%',
            transform: isMobile ? 
              `translateX(-${currentIndex * (100 / extendedPrizes.length)}%)` :
              `translateX(-${currentIndex * (100 / 3)}%)`,
            transition: isTransitioning ? 'transform 0.6s ease-in-out' : 'none'
          }}>
            {/* 복제된 아이템 배열 렌더링 */}
            {extendedPrizes.map((item, index) => (
              <div
                key={`${item.key}-${Math.floor(index / prizes.length)}-${index % prizes.length}`}
                style={{
                  width: isMobile ? `${100 / extendedPrizes.length}%` : '33.333%',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  padding: isMobile ? '0' : '0 10px',
                  flexShrink: 0
                }}
              >
                <div
                  style={{
                    width: '100%',
                    maxWidth: isMobile ? '100%' : '350px',
                    background: 'rgba(255, 255, 255, 0.05)',
                    borderRadius: 12,
                    padding: isMobile ? 30 : 25,
                    border: '1px solid rgba(255, 255, 255, 0.1)',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    minHeight: isMobile ? 280 : 320
                  }}
                >
                  <div style={{
                    width: isMobile ? 150 : 180,
                    height: isMobile ? 150 : 180,
                    marginBottom: isMobile ? 2 : 5,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    background: 'rgba(255, 255, 255, 0.1)',
                    borderRadius: 12
                  }}>
                    <img
                      src={item.image}
                      alt={`Prize ${(index % prizes.length) + 1}`}
                      style={{
                        maxWidth: '100%',
                        maxHeight: '100%',
                        objectFit: 'contain'
                      }}
                    />
                  </div>
                  <div style={{
                    textAlign: 'center',
                    color: '#fff',
                    fontSize: isMobile ? '0.9rem' : '1rem',
                    fontWeight: 600,
                    lineHeight: 1.4,
                    flex: 1,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '0 5px'
                  }}>
                    {item.text}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
        
        {/* 인디케이터 점들 */}
        <div style={{
          display: 'flex',
          justifyContent: 'center',
          gap: 8,
          marginTop: 30,
          marginBottom: 40
        }}>
          {prizes.map((_, index) => (
            <button
              key={index}
              onClick={() => setCurrentIndex(cloneCount + index)}
              style={{
                width: 12,
                height: 12,
                borderRadius: '50%',
                border: 'none',
                background: (currentIndex - cloneCount) % prizes.length === index ? '#ffb300' : 'rgba(255, 255, 255, 0.3)',
                cursor: 'pointer',
                transition: 'background-color 0.3s ease'
              }}
            />
          ))}
        </div>
      </div>
    </div>
  );
}

export default ProductHOPrize2;